import React from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import AddPlayerEmptyCard from '@/features/guardian/components/add-player-empty-card';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';

type EmptyKidsSectionProps = {
  onAddPlayerPress?: () => void;
};

export default function EmptyKidsSection({ onAddPlayerPress }: EmptyKidsSectionProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack paddingX={scale({ tablet: 0, phone: 20 })}>
      <Text variant="Font Guardian App/Body/Body 16 Bold" style={styles.sectionTitle}>
        {STRINGS.home.guardian.myKids}
      </Text>
      <AddPlayerEmptyCard onPress={onAddPlayerPress} />
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  sectionTitle: {
    color: colors['10'],
    marginBottom: scale(8),
  },
}));
